import src from "IMAGE";
export default { src, width: 227, height: 1245, blurWidth: 0, blurHeight: 0};
